// Initialize Airtable
export const config = {
    api_key: "keyvlNkb7NJ8hpDtZ",
    base_name: "appCy0MERJ2Tvzngf",
    table_name: "letter",
    view_name: "Grid"
  };